// console.log('Cart Error script loaded!');

function initCartErrorHandling() {
    // Get the cart container
    const cartContainer = document.querySelector('#wow-cart-drawer__panel');
    if (!cartContainer) {
       // console.log('Cart container not found, will retry...');
        setTimeout(initCartErrorHandling, 500);
        return;
    }

    // Check if cart is visible
    const isCartVisible = !cartContainer.classList.contains('wow-cart-hide');
    
    if (!isCartVisible) {
        // If cart is hidden, wait for it to become visible
        const observer = new MutationObserver((mutations) => {
            if (!cartContainer.classList.contains('wow-cart-hide')) {
                observer.disconnect();
                setupCartErrorHandling();
            }
        });

        observer.observe(cartContainer, {
            attributes: true,
            attributeFilter: ['class']
        });
        
        // Also try to set up immediately in case the cart is already visible but we missed the transition
        setTimeout(setupCartErrorHandling, 100);
    } else {
        setupCartErrorHandling();
    }
}

function setupCartErrorHandling() {
    const checkoutBtn = document.querySelector('.wow-cart-checkout-btn');
    const acceptNoteContainer = document.querySelector('.wow-cart-accept-note');
    
    if (!checkoutBtn || !acceptNoteContainer) {
        //console.log('Cart elements not found, will retry...');
        setTimeout(setupCartErrorHandling, 500);
        return;
    }

    //console.log('Cart elements found!');
    const checkbox = acceptNoteContainer.querySelector('input[type="checkbox"]');
    
    // Check if we've already set up the error message
    if (acceptNoteContainer.querySelector('.terms-error-message')) {
        return;
    }

    // Create and style the error message using HTML string
    const errorMessageHTML = `
        <div id="terms-error-message" class="terms-error-message">
        <div class="terms-error-message-in">Zgoda wymagana do akceptacji.</div>
        </div>
    `;

    // Insert the error message after the checkbox and text
    acceptNoteContainer.insertAdjacentHTML('beforeend', errorMessageHTML);
    const errorMessage = document.getElementById('terms-error-message');
    
    // Create overlay using HTML string with a class and ID
    const overlayHTML = `
        <div id="checkout-overlay" class="checkout-overlay">&nbsp;</div>
    `;

    // Add overlay to button container
    const buttonContainer = checkoutBtn.closest('.wow-cart-action-cta-buttons');
    if (buttonContainer) {
        buttonContainer.style.position = 'relative';
        buttonContainer.insertAdjacentHTML('beforeend', overlayHTML);
        
        // Get the overlay by ID
        const buttonOverlay = document.getElementById('checkout-overlay');
        
        // Handle overlay click
        buttonOverlay.addEventListener('click', function(e) {
            console.log('Overlay clicked!');
            if (checkoutBtn.disabled && (!checkbox || !checkbox.checked)) {
                // console.log('Button is disabled and checkbox is not checked!');
                e.preventDefault();
                e.stopPropagation();
                // console.log('Preventing default and stopping propagation!');
                
                // Show error message
                if (errorMessage) {
                    // console.log('Showing error message!');
                    errorMessage.style.display = 'block';
                    setTimeout(() => {
                        // console.log('Hiding error message!');
                        errorMessage.style.display = 'none';
                    }, 3000);
                }
            }
        });

        // Only show overlay when button is disabled
        const updateOverlay = () => {
            if (checkoutBtn.disabled) {
                // console.log('Button is disabled!');
                buttonOverlay.style.display = 'block';
            } else {
               // console.log('Button is not disabled!');
                buttonOverlay.style.display = 'none';
            }
        };
        
        // Initial update
        updateOverlay();
        
        // Watch for changes to the disabled state
        const observer = new MutationObserver(updateOverlay);
        observer.observe(checkoutBtn, {
            attributes: true,
            attributeFilter: ['disabled']
        });
    }
    
    // Hide error message when user checks the checkbox
    if (checkbox) {
        checkbox.addEventListener('change', function() {
            const buttonOverlay = document.getElementById('checkout-overlay');
            if (this.checked) {
                // Hide error message and overlay when checkbox is checked
                if (errorMessage) {
                    errorMessage.style.display = 'none';
                }
                if (buttonOverlay) {
                    buttonOverlay.style.display = 'none';
                }
            } else if (buttonOverlay) {
                // Only show overlay if button is disabled
                buttonOverlay.style.display = checkoutBtn.disabled ? 'block' : 'none';
            }
        });
    }
}

// Start the initialization
document.addEventListener('DOMContentLoaded', initCartErrorHandling);

// Also try initializing when the cart is opened
document.addEventListener('click', function(e) {
    if (e.target.closest('[data-cart-trigger], .cart-toggle, .cart-icon, .wow-cart-header__close-btn')) {
        setTimeout(initCartErrorHandling, 300);
    }
});